import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import LeadDetails from "./details";
import {getLeadDetails,updateLeadStatus} from '../../../service/LeadManagement/action.js';

const mapStateToProps = (state) => ({
    // referralList:state.Referral.referralList,
    // referralDetails:state.Referral.referralDetails,
    // referralApproval:state.Referral.referralApproval,
    leadDetails:state.LeadManagement.leadDetails,
    updatedLead:state.LeadManagement.updatedLead,    
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLeadDetails,
            updateLeadStatus
            // getAllReferrals,
            // viewReferralDetails,
            // updateReferralStatus
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadDetails);
